import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'moet-core';

import { ServerErrorAlert } from './ServerErrorAlert';

export const ErrorAlert = ({ error }) => {
  if (typeof error === 'object') {
    return <ServerErrorAlert error={error} />;
  }

  return <Alert type="error" content={error} />;
};

ErrorAlert.propTypes = {
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};
